<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height printable">
                <v-card-title>
                    <h2>{{ $t("contacts") }}</h2>
                </v-card-title>

                <v-container fluid grid-list-md class="v-scrollable">
                    <v-container>
                        <v-flex text-xs-center>
                            <v-img
                                :src="require(`@/assets/av-${logoLocale}.png`)"
                                width="250px"
                                style="margin: 0 auto;"
                                contain
                            ></v-img>
                        </v-flex>
                    </v-container>
                    <v-container>
                        <v-flex text-xs-center>
                            <v-img
                                :src="require(`@/assets/vps.webp`)"
                                width="250px"
                                style="margin: 0 auto;"
                                contain
                            ></v-img>
                        </v-flex>
                    </v-container>
                    <v-card-text>
                        <v-flex text-xs-center>
                            <span style="font-weight: bold;">{{ $t("site") }}: </span><a href="http://www.vektorpromsoft.ru/" target="_blank">http://www.vektorpromsoft.ru/</a><br>
                            <span style="font-weight: bold;">{{ $t("eMail") }}: </span><a href="mailto:mail@vektorpromsoft.ru" target="_blank">mail@vektorpromsoft.ru</a><br>
                            <span style="font-weight: bold;">{{ $t("phone") }}: </span>+7 (8182) 410-330<br>
                        </v-flex>
                        <v-flex text-xs-center mt-3>
                            <span>OOO «{{ $t("vektorPromSoft") }}»</span><br>
                            <span>ИНН: 2901309790</span><br>
                            <span>ОГРН: 1222900002874</span><br>
                        </v-flex>
                    </v-card-text>
                </v-container>
            </v-card>
            <message-box ref="MessageBox"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import MessageBox from "@/components/dialogs/MessageBox";

    export default {
        name: "ContactsInfo",

        components: {
            MessageBox
        },

        data () {
            return {
                logoLocale: "cyr"
            }
        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            locale () { return this.$i18n.locale }
        },

        watch: {
            locale: function (val) {
                this.applyLocale(val);
            }
        },

        mounted () {
            this.applyLocale(this.$vuetify.lang.current);

            this.$watch(
                "$vuetify.lang.current",
                (val) => {
                    this.applyLocale(val);
                }
            );

        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale (locale) {
                this.logoLocale = locale == "ru" ? "cyr" : "lat";
            }
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 128px)
</style>
